import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Button, HStack, List, ListIcon, ListItem, Tag, Text, VStack, useColorModeValue } from '@chakra-ui/react';
import { CheckIcon } from '@chakra-ui/icons';

function PriceWrapper(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(Box, {
    mb: 4,
    shadow: "base",
    borderWidth: "1px",
    alignSelf: {
      base: 'center',
      lg: 'flex-start'
    },
    borderColor: useColorModeValue('gray.200', 'gray.500'),
    borderRadius: 'xl',
    children: children
  });
}

var PricingCard = function PricingCard(_ref2) {
  var name = _ref2.name,
      currency = _ref2.currency,
      amount = _ref2.amount,
      period = _ref2.period,
      label = _ref2.label,
      _ref2$features = _ref2.features,
      features = _ref2$features === void 0 ? [] : _ref2$features,
      onSelect = _ref2.onSelect,
      upperLabel = _ref2.upperLabel,
      setupFee = _ref2.setupFee;
  var upperBg = useColorModeValue('primaryPurple.300', 'primaryPurple.700');
  var upperColor = useColorModeValue('gray.900', 'gray.300');
  var priceString = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: currency,
    minimumFractionDigits: 0
  }).format(amount / 100);
  return /*#__PURE__*/_jsx(PriceWrapper, {
    children: /*#__PURE__*/_jsxs(Box, {
      position: "relative",
      children: [!!upperLabel && /*#__PURE__*/_jsx(Box, {
        position: "absolute",
        top: "-16px",
        left: "50%",
        style: {
          transform: 'translate(-50%)'
        },
        children: /*#__PURE__*/_jsx(Text, {
          textTransform: "uppercase",
          bg: upperBg,
          px: 3,
          py: 1,
          color: upperColor,
          fontSize: "sm",
          fontWeight: "600",
          rounded: "md",
          children: upperLabel
        })
      }), /*#__PURE__*/_jsxs(Box, {
        py: 4,
        px: 12,
        children: [/*#__PURE__*/_jsx(Text, {
          fontWeight: "500",
          fontSize: "2xl",
          children: name
        }), /*#__PURE__*/_jsxs(HStack, {
          justifyContent: "center",
          children: [/*#__PURE__*/_jsx(Text, {
            fontSize: "5xl",
            fontWeight: "900",
            children: priceString
          }), /*#__PURE__*/_jsxs(Text, {
            fontSize: "3xl",
            color: "gray.500",
            children: ["/", period]
          })]
        }), /*#__PURE__*/_jsx(Text, {
          color: 'gray.500',
          fontWeight: "600",
          children: "for publisher"
        })]
      }), /*#__PURE__*/_jsxs(VStack, {
        bg: useColorModeValue('gray.50', 'gray.700'),
        py: 4,
        borderBottomRadius: 'xl',
        children: [/*#__PURE__*/_jsxs(List, {
          spacing: 3,
          textAlign: "start",
          px: 12,
          children: [!!setupFee && /*#__PURE__*/_jsxs(ListItem, {
            children: ["Setup fee ", setupFee, " ", /*#__PURE__*/_jsx(Tag, {
              colorScheme: "blue",
              children: "One time"
            })]
          }), features.map(function (instance, i) {
            return /*#__PURE__*/_jsxs(ListItem, {
              children: [/*#__PURE__*/_jsx(ListIcon, {
                as: CheckIcon,
                color: "green.500"
              }), instance]
            }, i);
          })]
        }), !!onSelect && /*#__PURE__*/_jsx(Box, {
          w: "80%",
          pt: 7,
          children: /*#__PURE__*/_jsx(Button, {
            w: "full",
            colorScheme: "brand",
            variant: "outline",
            onClick: onSelect,
            children: label
          })
        })]
      })]
    })
  });
};

export default PricingCard;